import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import CustomPagination from './clipping.custompagination';
import columns from './resume.admin.columns';
import { exportTableToCSV } from './clipping.export';
import { exportTableToJSON } from './clipping.export';
import { fetchClippings } from 'store/action/resume.clipping.action';
import { fetchUsersRecords } from 'store/action/records.action';
import history from 'config/history';

class resumeClipping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      row: '',
      filter: true,
      columns: columns,
    };
    this.changeFilter = this.changeFilter.bind(this);
    this.handleRowChange = this.handleRowChange.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleDownloadToJson = this.handleDownloadToJson.bind(this);
  }

  componentWillMount() {
    this._fetchAllClippings();
    this._fetchUsersRecords();
  }

  handleRowChange = row => event => {
    if (event.target.value !== 0) {
      this.setState({
        row: event.target.value,
      });
    }
  };

  handleDownload() {
    const data = this.reactTable.getResolvedState().sortedData;
    exportTableToCSV(data, columns, 'data.csv');
  }
  handleDownloadToJson() {
    const data = this.reactTable.getResolvedState().sortedData;
    exportTableToJSON(data, 'data.json');
  }
  changeFilter() {
    this.setState({
      filter: !this.state.filter,
    });
  }

  _fetchAllClippings() {
    return fetchClippings()
      .then(({ data }) => {
        let finalData = [];
        this._fetchUsersRecords();
        if (
          this.state.records !== null &&
          data !== null &&
          this.state.records !== [] &&
          data !== [] &&
          this.state.records !== undefined &&
          data !== undefined
        ) {
          data.forEach(item => {
            finalData.push({
              ...item,
              isRecordEdit: false,
            });
          });

          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < this.state.records.length; j++) {
              if (this.state.records[j].event_id === data[i].id) {
                finalData[i].isRecordEdit = true;
              }
            }
          }
        }
        this.setState({
          data: finalData,
        });
      })
      .catch(e => {
        console.error(e);
        return this.setState({
          data: [],
        });
      });
  }

  _fetchUsersRecords() {
    return fetchUsersRecords()
      .then(({ records }) => {
        this.setState({
          records: records,
        });
        records.forEach(item => {});
      })
      .catch(e => {
        console.error(e);
        return this.setState({
          records: [],
        });
      });
  }

  toggleColumnChooser = index => {
    this.setState(prevState => {
      const columns1 = [];
      columns1.push(...columns);
      columns1[index].show = !columns1[index].show;
      if (columns1[index].columns) {
        columns1[index].columns.forEach(item => {
          item.show = !item.show;
        });
      }
      return {
        columns: columns1,
      };
    });
  };

  render() {
    const onRowClick = (state, rowInfo, column, instance) => {
      return {
        onClick: e => {
          if (column.Header !== 'Minuta' && rowInfo !== undefined) {
            rowInfo.row.protocol = '';
            history.push('/evento/editar', rowInfo);
          } else if (
            this.state.records !== null ||
            this.state.records !== [] ||
            this.state.records !== undefined
          ) {
            this.state.records.forEach(record => {
              if (record.event_id === rowInfo.original.id) {
                const title = rowInfo.original.Actions_action;
                const jsonMessage = [];
                jsonMessage.push(record);
                jsonMessage.push({ isRecordEdit: true, title });
                history.push(`/template/${rowInfo.original.id}`, jsonMessage);
              }
            });
          }
        },
      };
    };
    const columns = this.state.columns;
    const translations = {
      previousText: 'Anterior',
      nextText: 'Próximo',
      loadingText: 'Carregando...',
      noDataText: 'Nenhum evento encontrado',
      pageText: 'Página',
      ofText: 'de',
      rowsText: 'linhas',
    };
    return (
      <>
        <div className="App">
          <h3 align="center" style={{ paddingTop: 8, fontWeight: 'bold' }}>
            Lista de eventos
          </h3>
          <ReactTable
            {...translations}
            ref={r => (this.reactTable = r)}
            data={this.state.data}
            filterable={this.state.filter}
            changeFilter={this.changeFilter}
            handleDownloadToJson={this.handleDownloadToJson}
            handleDownload={this.handleDownload}
            columns={columns}
            onColumnUpdate={this.toggleColumnChooser}
            showPageSizeOptions={true}
            defaultPageSize={10}
            showPaginationBottom={true}
            PaginationComponent={CustomPagination}
            pageSizeOptions={[10, 25, 50, 100]}
            getTheadGroupProps={(state, rowInfo, column, rtInstance) => {
              return {
                style: {
                  backgroundColor: '#B3E5FC',
                },
              };
            }}
            getTdProps={onRowClick}
          />
        </div>
      </>
    );
  }
}

export default resumeClipping;
